import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import CustomModal from "components/CustomModal";

function SubscriptionResponse() {
  const navigate = useNavigate();
  let params = useParams();
  const isSuccess = params.responseType;
  const actionType = params.actionType;
  const closeModal = () => {
    actionType === "subscription"
      ? navigate("/subscription")
      : navigate("/enrollments");
  };
  return (
    <div>
      <CustomModal
        variant={isSuccess === "success" ? "success" : "error"}
        text={
          actionType === "subscription"
            ? isSuccess === "success"
              ? "subscription_purchased_success"
              : "subscription_purchased_fail"
            : isSuccess === "success"
            ? "enrollment_purchased_success"
            : "enrollment_purchased_fail"
        }
        header=""
        onClose={closeModal}
        buttons={[
          {
            text: "ok",
            variant: "blue-1",
            onClick: "closeModal",
            loading: false,
            disabled: false,
          },
        ]}
        functionsList={{ closeModal }}
      />
    </div>
  );
}

export default SubscriptionResponse;
